export enum DocumentType {
    GENERAL_CONDITIONS = 'GENERAL_CONDITIONS',
    CANCELLATION_POLICY = 'CANCELLATION_POLICY',
    DENIAL_POLICY = 'DENIAL_POLICY',
    OTHER_DOCUMENTS = 'OTHER_DOCUMENTS' 
}